import { fromJS } from "immutable";

export default {
	convertAuthorSelect: {
		any_employee: "anyEmployee",
		subject: "subject",
		manager_or_chain_of_command: "managerChainOfCommand",
		admin_or_group_admin: "admin",
	},

	notEditingDisplayLookup: {
		anyEmployee: "Any Employee",
		subject: "Subject",
		managerChainOfCommand: "Manager",
		admin: "Admin",
		self: "Self",
		subjectAnyEmployee: "Any Employee",
		static: "Static",
		relative: "Relative",
		noApprovalRequired: "No approval",
		managersOrAdmins: "Require approval from managers or admins",
		admins: "Require approval from admins",
	},

	selectAuthorOptions: fromJS([
		{ id: "anyEmployee", label: "Any Employee" },
		{ id: "subject", label: "Subject" },
		{ id: "managerChainOfCommand", label: "Manager" },
		{ id: "admin", label: "Admin" },
	]),

	subjectTypeOptions: fromJS([
		{ id: "self", label: "Self" },
		{ id: "anyEmployee", label: "Any Employee" },
	]),

	selectApprovalOptions: fromJS([
		{ id: "noApprovalRequired", label: "No approval" },
		{
			id: "managersOrAdmins",
			label: "Require approval from managers or admins",
		},
		{ id: "admins", label: "Require approval from admins" },
	]),

	selectApprovalFormat: {
		noApprovalRequired: null,
		managersOrAdmins: "managers-and-admins",
		admins: "admins-only",
	},
};
